import React from "react";
import { useBoxStyles } from "../Context/BoxContext";
import { Button, Col, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const BoxWithContent = () => {
  const {
    boxStyles,
    contentStyles,
    heading,
    description,
    image,
    buttonVariant,
    boxStyles2,
    heading2,
    description2,
    image2,
    buttonVariant2,
    link1,
    link2,
    showButton, // Destructure showButton
  } = useBoxStyles();

  const headingStyle = {
    fontFamily: '"Inria Serif", serif',
    fontWeight: "600",
    fontSize: "2rem",
    textAlign: "center",
  };

  const descriptionStyle = {
    textAlign: "center",
    fontSize: "1rem",
    marginTop: "7.5%",
    marginBottom: "7.5%",
  };

  return (
    <Container style={{ paddingLeft: "10%", paddingRight: "10%" }}>
      {/* First Box */}
      <div style={boxStyles}>
        <div style={contentStyles}>
          <Row>
            <Col md={6}>
              <img
                src={image}
                className="img-fluid"
                style={{
                  maxWidth: "90%",
                  height: "auto",
                  minHeight: "16rem",
                  borderRadius: "25px",
                  float: "right",
                  marginRight: "15px",
                }}
              />
            </Col>

            <Col md={6}>
              <h2 style={headingStyle}>{heading}</h2>
              <p style={descriptionStyle}>{description}</p>
              {showButton && ( // Conditionally render the first button
                <Link to={link1} style={{ textDecoration: "none" }}>
                  <Button
                    variant={buttonVariant}
                    style={{
                      textAlign: "center",
                      padding: "10px 20px",
                      display: "block",
                      margin: "0 auto",
                      borderRadius: "25px",
                    }}
                  >
                    Find Out More
                  </Button>
                </Link>
              )}
            </Col>
          </Row>
        </div>
      </div>

      {/* Second Box */}
      <div style={boxStyles2}>
        <div style={contentStyles}>
          <Row>
            <Col md={6}>
              <h2 style={headingStyle}>{heading2}</h2>
              <p style={descriptionStyle}>{description2}</p>
              {showButton && ( // Conditionally render the second button
                <Link to={link2} style={{ textDecoration: "none" }}>
                  <Button
                    variant={buttonVariant2}
                    style={{
                      textAlign: "center",
                      padding: "10px 20px",
                      display: "block",
                      margin: "0 auto",
                      marginBottom: "10%",
                      borderRadius: "25px",
                    }}
                  >
                    Find Out More
                  </Button>
                </Link>
              )}
            </Col>

            <Col md={6}>
              <img
                src={image2}
                className="img-fluid"
                style={{
                  maxWidth: "90%",
                  height: "auto",
                  minHeight: "16rem",
                  borderRadius: "25px",
                  float: "left",
                  marginLeft: "15px",
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default BoxWithContent;